import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ApiService } from 'src/app/core/http/api.service';
import { DeviceDetectorService } from 'src/app/shared/services/device-detector.service';

@Component({
  selector: 'notificationes-cajero',
  templateUrl: './cajero.component.html',
  styleUrls: ['./cajero.component.css'],
})
export class CajeroComponent implements OnInit {
  public loadingBonos = true;
  public bonos: {
    creditsAmount: number;
    createdAt: string;
    id: string;
  }[] = [];

  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter();
  @Input() public show: boolean = false;
  @Input() public newNoti: boolean = false;
  @Input() public isDisabled: boolean = false;

  constructor(private readonly elementRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.onClose.emit();
    }
  }

  toggle() {
    this.onToggle.emit();
  }
  closeModal() {
    this.onClose.emit();
  }
}
